import { SUBJECTS, subjectLessons, type Lesson, type Subject } from '@typing-racer/shared';
import { clear, h, pct } from '../dom.js';
import type { LessonRecord } from '../lesson.js';

const stars = (n: number) => '★'.repeat(n) + '☆'.repeat(3 - n);

export function renderSubjects(
  root: HTMLElement,
  progress: Record<string, LessonRecord>,
  selected: Subject | null,
  actions: { select(s: Subject | null): void; start(lesson: Lesson): void; back(): void },
): void {
  clear(root);
  const body: HTMLElement[] = [];
  if (!selected) {
    body.push(
      h('p', { class: 'muted' }, 'Pick a subject. Every line you type is a real fact, so you pick up knowledge while you practise. Subjects can also be chosen as the sentence pack for a race.'),
      h(
        'div',
        { class: 'languages' },
        SUBJECTS.map((sub) => {
          const lessons = subjectLessons(sub);
          const earned = lessons.reduce((n, l) => n + (progress[l.id]?.stars ?? 0), 0);
          return h(
            'button',
            { class: 'lang-card', onclick: () => actions.select(sub) },
            h('span', { class: 'flag' }, sub.icon),
            h('b', {}, sub.name),
            h('span', { class: 'muted small' }, `${sub.sets.length} sets · ${sub.sets.reduce((n, s) => n + s.facts.length, 0)} facts`),
            h('span', { class: `stars${earned ? '' : ' none'}` }, `${earned}/${lessons.length * 3} ★`),
          );
        }),
      ),
    );
  } else {
    const lessons = subjectLessons(selected);
    body.push(
      h('div', { class: 'row' }, h('button', { class: 'btn small ghost', onclick: () => actions.select(null) }, '← All subjects'), h('h2', { style: 'margin:0' }, `${selected.icon} ${selected.name}`)),
      h(
        'div',
        { class: 'lessons' },
        lessons.map((l, i) => {
          const rec = progress[l.id];
          const set = selected.sets[i]!;
          return h(
            'div',
            { class: 'lesson-card' },
            h('div', { class: 'lesson-num' }, String(i + 1)),
            h('div', { class: 'lesson-body' }, h('b', {}, set.title), h('div', { class: 'muted small' }, set.facts[0])),
            h(
              'div',
              { class: 'lesson-side' },
              h('div', { class: `stars${rec ? '' : ' none'}` }, stars(rec?.stars ?? 0)),
              rec ? h('div', { class: 'muted small' }, `Best ${Math.round(rec.bestWpm)} WPM, ${pct(rec.bestAccuracy)}`) : h('div', { class: 'muted small' }, 'Not started'),
              h('button', { class: 'btn small primary', onclick: () => actions.start(l) }, rec ? 'Practise again' : 'Start'),
            ),
          );
        }),
      ),
    );
  }
  root.append(
    h(
      'div',
      { class: 'center' },
      h(
        'div',
        { class: 'panel wide stack' },
        h('div', { class: 'row', style: 'justify-content:space-between' }, h('h1', {}, '🧠 Learn a subject'), h('button', { class: 'btn small ghost', onclick: actions.back }, '← Back')),
        body,
      ),
    ),
  );
}
